'use strict';

import Loader from '../../../_modules/loader/loader';

import { isFieldEmpty, displayErrors, debounce } from './_helper';
import { toaster } from './_material';

let $tenderManagement = $('.tender-management'),
    $uploadFileModal = $('.js-tender-list-file'),
    $modalTenderProductFiles = $('.select-file_tenders'),
    $attemptUploadTenderFileBtn = $('.js-attempt-upload-tender-file'),
    $uploadTenderFileBtn = $('.js-upload-tender-file'),
    $cancelTenderUploadBtn = $('.js-cancel-tender-upload'),
    $selectTenderFileInput = $('input.input-upload-tender-file'),
    popupInterruptTenderHtml = '',
    popupInterruptTenderTmp = '',
    loader = new Loader(),
    obj = {},
    _regimens = [],
    _isInvalid = [];

$(() => {
    if (!$tenderManagement.length) {
        return false;
    }

    // render doT template only if needed
    if($('#popup-tender-interrupt-tmp').length)
      popupInterruptTenderTmp = doT.template($('#popup-tender-interrupt-tmp').html());

    $uploadFileModal.on('click', function (e) {

        e.preventDefault();

        $modalTenderProductFiles.slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false,
            complete: function () {
                $('body').addClass('fixed');
            }
        });
    });

    //function called when user click on upload file btn
    $attemptUploadTenderFileBtn.on('click', function (e) {
      let isMobileDevice = Modernizr.mq('(max-width: 767px)'),
      $errorContainer = $(this).parent().siblings('.server-errors__wrap');

      var data = new FormData();

      var files = $("#TenderPricingFile").get(0).files;

      // Add the uploaded image content to the form data collection
      if (files.length > 0) {
           data.append("TenderProductListFile", files[0]);
      }

      loader.fadeIn();

      //need to POST file, same call as upload
      $.ajax({
          url: '/api/tenders/cancelledregimens',
          type: 'POST',
          headers: {__RequestVerificationToken: $('#upload-tender-file-form').find('input[name=__RequestVerificationToken]').val()},
          contentType: false,
          processData: false,
          data: data,
          success: function (data) {
              _regimens = data.regimens;
              loader.fadeOut();

              if(_regimens.length){
                //show interrupt message with regimen ids that would be cancelled
                  obj = {},
                  popupInterruptTenderHtml = '';

                  obj = {
                      "regimens": _regimens
                  };

                  popupInterruptTenderHtml += popupInterruptTenderTmp(obj);
              }else{
                //no regimens would be cancelled
                //show generic warning message
                popupInterruptTenderHtml = "<p> Uploading a pricing file will completely override all existing tenders and tender pricings.<br>Are you sure you would like to continue?</p> <div class=\"cta--wrapper\"> <a href=\"#\" data-id=\"\" class=\"cta cta__primary js-upload-tender-file\">Upload File</a> <a href=\"#\" data-id=\"\" class=\"cta cta__primary js-cancel-tender-upload\">Cancel</a> <div class=\"col-10 col-offset-2 server-errors__wrap js-error--upload-tender-pricing-file\"> <div class=\"container\"> <div class=\"server-errors wrap\"></div> </div></div> </div> ";
              }

              $('.popup-tender-interrupt').html(popupInterruptTenderHtml);

              $.fancybox.open('#tender-active', {
                  autoSize: false,
                  closeBtn: false,
                  fitToView: false,
                  height: isMobileDevice == true ? 300 : 200,
                  width: isMobileDevice == true ? 250 : 500,
                  padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
                  type: 'inline',
                  wrapCSS: 'modal',
                  helpers: {
                      overlay:{
                          closeClick: true
                      }
                  }
              });
          },
          error: function (error) {
              loader.fadeOut();
              displayErrors(error, $errorContainer );
          }
      });
    });


    $(document).on('click', '.js-cancel-tender-upload', function(e){
      $.fancybox.close();
    });

    $(document).on('click', '.js-upload-tender-file', function(e){
      e.preventDefault();
      let $errorContainer = $(this).parent().siblings('.server-errors__wrap');
      _isInvalid = [];

      if (isFieldEmpty($selectTenderFileInput)){

          $selectTenderFileInput
              .parent().addClass('incomplete')
              .find('.error').slideDown({
              duration: 500,
              easing: 'easeOutExpo',
              queue: false
          });

          _isInvalid.push(0);
      }

      if (_isInvalid.length > 0) {
          $(this).addClass('error');
          return false;
      } else {

          var data = new FormData();

          var files = $("#TenderPricingFile").get(0).files;

          // Add the uploaded image content to the form data collection
          if (files.length > 0) {
               data.append("TenderProductListFile", files[0]);
          }

          _isInvalid = [];

          $(this).removeClass('error');

          loader.fadeIn();

          //ajax call to save tender
          $.ajax({
              url: '/api/tenders/upload',
              type: 'POST',
              headers: {__RequestVerificationToken: $('#upload-tender-file-form').find('input[name=__RequestVerificationToken]').val()},
              contentType: false,
              processData: false,
              data: data,
              success: function (data) {
                  $.fancybox.close();
                  loader.fadeOut();
                  toaster('File uploaded, Tenders and pricings updated.');
                  window.location.href = data.href;
              },
              error: function (error) {
                  $.fancybox.close();
                  loader.fadeOut();
                  displayErrors(error, $errorContainer );
              }
          });
      }

    });



});
